import catchCancel from 'helpers/catchCancel';
import { invoice as invoiceApi } from 'utilities/api';

export const defaultValues = {
  invoiceNumber: '',
  vendor: '',
  invoiceDate: new Date(Date.now()),
  invoiceDueDate: '',
  cropSeason: JSON.parse(localStorage.getItem('selectedCropSeasons')) || [],
  notes: '',
  flagIds: [],
  invoiceProducts: []
};

export const fetchInvoiceById = (
  invID,
  setInvoice,
  removeInvoiceNumber,
  setLoading = () => {}
) => {
  const getInvoiceApi = invoiceApi.createChildApi({
    action: `invoice/${invID}`
  });
  const { promise } = getInvoiceApi.fetch();
  promise
    .then(({ data }) => {
      if (data) {
        const inv = {
          ...data,
          invoiceNumber: removeInvoiceNumber ? '' : data?.invoiceNumber,
          invoiceDate: new Date(data?.invoiceDateEpoch),
          invoiceDueDate: new Date(data?.invoiceDueDate),
          cropSeason: data?.cropSeasons?.[0]?.seasonId,
          flagIds: data.flagIds?.reduce((flagIds, flagId) => {
            return `${flagIds},${flagId}`;
          })
        };
        if (
          inv?.invoiceDueDate instanceof Date &&
          !isNaN(inv.invoiceDueDate) &&
          inv.invoiceDueDate.toISOString() === '1970-01-01T00:00:00.000Z'
        ) {
          delete inv.invoiceDueDate;
          delete inv.invoiceDueDateEpoch;
        }
        setInvoice(inv);
      }
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
      catchCancel(err);
    });
};
